<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content>
  <div style="color:green" [innerHTML]="data.text"></div><br>
  <div>
    <ng-container *ngFor="let container of data.containers">
      <input type="checkbox" value="{{ container.isChecked }}" [checked]="container.isChecked" (change)="container.isChecked = !container.isChecked" /><mat-label style="font-size:medium"> {{container.id}} </mat-label><mat-label style="font-size:x-small"> {{container.daysOnSite}} day(s)</mat-label>
      <br>
    </ng-container><br>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button *ngIf="data.showCancel" class="btn btn-light" mat-button mat-dialog-close>Cancel</button>
  <button *ngIf="containersChecked(data.containers)" class="btn btn-primary" mat-button [mat-dialog-close]="data" cdkFocusInitial>Ok</button>
</mat-dialog-actions>
